export const SAVE_STOCK_ENTRY_ACTION = 'SAVE_STOCK_ENTRY_ACTION'
export const SAVE_STOCK_ENTRY_SUCCESS = 'SAVE_STOCK_ENTRY_SUCCESS'


export const GET_STOCK_COUNT_ACTION = 'GET_STOCK_COUNT_ACTION'
export const GET_STOCK_COUNT_ACTION_SUCCESS = 'GET_STOCK_COUNT_ACTION_SUCCESS'

export const CHECK_STOCK_ENTERY_FOR_FIRST_TRANSACTION = 'CHECK_STOCK_ENTERY_FOR_FIRST_TRANSACTION'
export const CHECK_STOCK_ENTERY_FOR_FIRST_TRANSACTION_SUCCESS = 'CHECK_STOCK_ENTERY_FOR_FIRST_TRANSACTION_SUCCESS'

export const CHECK_STOCK_ENTERY_FOR_BACKDATED_TRANSACTION = 'CHECK_STOCK_ENTERY_FOR_BACKDATED_TRANSACTION'
export const CHECK_STOCK_ENTERY_FOR_BACKDATED_TRANSACTION_SUCCESS = 'CHECK_STOCK_ENTERY_FOR_BACKDATED_TRANSACTION_SUCCESS'

export const GET_ITEM_DROPDOWM_ACTION = 'GET_ITEM_DROPDOWM_ACTION'
export const GET_ITEM_DROPDOWM_ACTION_SUCCESS = 'GET_ITEM_DROPDOWM_ACTION_SUCCESS'

export const GET_STOCK_ENTRY_LIST_ACTION = 'GET_STOCK_ENTRY_LIST_ACTION'
export const GET_STOCK_ENTRY_LIST_SUCCESS = 'GET_STOCK_ENTRY_LIST_SUCCESS'

export const GET_STOCK_ENTRY_VIEW_ACTION = 'GET_STOCK_ENTRY_VIEW_ACTION'
export const GET_STOCK_ENTRY_VIEW_SUCCESS = 'GET_STOCK_ENTRY_VIEW_SUCCESS'

export const GET_LAST_STOCK_ENTRY_SUCCESS = 'GET_LAST_STOCK_ENTRY_SUCCESS'


export const DELETE_STOCK_ENTRY = 'DELETE_STOCK_ENTRY'
export const DELETE_STOCK_ENTRY_SUCCESS = 'DELETE_STOCK_ENTRY_SUCCESS'



export const STOCK_ENTRY_API_ERROR_ACTION = 'STOCK_ENTRY_API_ERROR_ACTION'
